module.exports = __webpack_public_path__ + "static/media/veneto-village-16.0555af19.jpg";